module.exports = __webpack_public_path__ + "static/media/6.d2e3f248.jpeg";